import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Select } from 'antd'
import { PaperSizes } from '../../constants'

const { Option } = Select

const Constituent = (props) => {
	const { 
		onSelectedItem, onChange, ...rest 
	} = props
	// const [searchText, setSearchText] = useState('')

	return (
		<Select 
			allowClear
			placeholder='Select Paper Size'
			onChange={(value) => {
				if (onSelectedItem) {
					const mPapersize = _.find(PaperSizes, (i) => _.isEqual(i.name, value))
					onSelectedItem(mPapersize)
				}
				onChange(value)
			}}
			{ ...rest }
		>
			{
				PaperSizes.map((item, key) => (
					<Option key={key} value={item.name}>
						{item.name}
					</Option>
				))
			}
		</Select>
	)
}

const composed = compose(
	// withApollo
)

export default composed(Constituent)